import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

type Variant = 'full' | 'symbol';

interface LogoProps {
  variant?: Variant;
  className?: string;
  alt?: string;
}

const FULL_LIGHT  = '/logo/logo-light.png';
const FULL_DARK   = '/logo/logo-dark.png';
const SYMBOL      = '/logo/symbol.png';

export function Logo({ variant = 'full', className, alt = 'DealerWorks' }: LogoProps) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (variant === 'symbol') {
    return <img src={SYMBOL} alt={alt} className={cn('h-6 w-6 select-none', className)} draggable={false} />;
  }

  // Avoid a theme-mismatch flash on first paint — render the light variant
  // until `next-themes` tells us what the user actually picked.
  const src = mounted && resolvedTheme === 'dark' ? FULL_DARK : FULL_LIGHT;

  return (
    <img
      src={src}
      alt={alt}
      className={cn('h-7 w-auto select-none', className)}
      draggable={false}
    />
  );
}
